export const loadingStatusShow = 'loadingStatusShow';
export const loadingStatusHide = 'loadingStatusHide';
export const toggleMobileMenu = 'toggleMobileMenu';
export const togglePopup = 'togglePopup';
export const popupType = 'popupType';



// WEBPACK FOOTER //
// ./src/store/mutations_type.js